import MatchPlayHeader from './match-play-header'

export default MatchPlayHeader
